import { COMMON_SHARE_CHANNELS } from '@/components/share/platformConfig'
import { urlParse } from '@/common/js/utils'
import { util } from '@didi/soda-common'
import Api from '@/api'
import store from '@/store'
const { env } = util
const { country: _country } = store.state

const QUERY_PARAMS = urlParse()
const COUNTRY = QUERY_PARAMS.poiCountryCode || QUERY_PARAMS.countryCode
const country = COUNTRY === 'BR' ? COUNTRY : _country

// 获取各渠道需要配置的字段
function getShareField(channel) {
  const defaultFiled = ['title', 'url', 'content', 'icon']
  const channelShareField = {
    facebook: ['url', 'icon', 'content', 'title'],
  }
  return channelShareField[channel] || defaultFiled
}

// 基本规则：
// 无文本区时卡片内容使用活动的标题与副标题
// 有文本区时，卡片使用默认的品牌相关的默认文案
// 所以需要在链接中标识是否存在文本内容，以便ssr获取标识并生成对应的meta标签
async function getShortLinks(shareUrl) {
  const shortLinkKey = country === 'BR' ? 'short_url_99' : 'short_url'
  const shortLinkRequests = Promise.all([
    Api.getShortLink({ url: shareUrl }),
    Api.getShortLink({ url: `${shareUrl}&noContent=1` }),
  ])
  const shortLinkResponses = await shortLinkRequests
  return shortLinkResponses.map(res => res.data[shortLinkKey])
}

// 获取分享配置，由于CGC & DGD的差异逐渐变大，遂将配置生成方法分割
// CGC短链在公共方法中请求，DGD在点击分享按钮时生成
// CGC使用配置化的渠道字段
// onelink链接无需转短链
export async function getShareConfig(share, shareUrl, channelOrder, isNeedShort = true) {
  const [shortLink, shortLinkWithoutContent] = isNeedShort
    ? await getShortLinks(shareUrl)
    : [shareUrl, `${shareUrl}&noContent=1`]
  const commonConfig = share.default || {}
  const res = {
    common: {
      title: commonConfig.title,
      url: shortLink,
      content: commonConfig.content,
      icon: commonConfig.icon,
    },
  }

  // 配置渠道
  // 存在顺序则按照顺序处理以便前端按顺序展示
  channelOrder.forEach(channel => {
    const channelFiled = getShareField(channel)
    const allFiled = {
      title: share[channel] ? share[channel].title : commonConfig.title,
      // 对有无content在短链中进行标识，并在ssr被推荐人页中进行区别处理
      url: channelFiled.includes('content') ? shortLink : shortLinkWithoutContent,
      content: share[channel] ? share[channel].content : commonConfig.content,
      icon: share[channel] ? share[channel].icon : commonConfig.icon,
    }
    // 渠道级别的字段可以使用getShareField方法
    // 在channelShareField中配置即可
    res[channel] = res[channel] || {}
    channelFiled.forEach(filed => {
      res[channel][filed] = allFiled[filed]
    })
  })

  // 公共渠道 (sms, email, systemEntrance)
  COMMON_SHARE_CHANNELS.forEach(channel => {
    res[channel] = {
      title: commonConfig.title,
      url: shortLink,
      content: commonConfig.content,
      icon: env.isIOS ? commonConfig.icon : '',
    }
  })
  return res
}
